import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Fee_Due_for_Siblings.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Fee_Due_for_Siblings() {
  const [siblingData, setSiblingData] = useState([]);
  const [parents, setParents] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedParent, setSelectedParent] = useState("");

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        id: selectedParent,
      };

      const response = await simplePostCall(
        ApiConfig.siblingsreportsReport,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setSiblingData(response.data || []);
        if (response.parents_list && parents.length === 0) {
          setParents(response.parents_list);
        }
      }
    } catch (error) {
      console.error("Error fetching sibling report:", error);
    } finally {
      setLoading(false);
    }
  }, [selectedParent, parents.length]);

  useEffect(() => {
    fetchInitialData();
  }, [selectedParent]);

  const isZero = (v) => v === 0 || v === "0";

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Fee Due for Siblings</h4>
        <button className="btn btn-primary">Export</button>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select
            className="form-select"
            value={selectedParent}
            onChange={(e) => setSelectedParent(e.target.value)}
          >
            <option value="">Select Parent</option>
            {parents.map((parent) => (
              <option key={parent.user_id} value={parent.user_id}>
                {parent.user_name} (ID: {parent.user_id})
              </option>
            ))}
          </select>
          <button
            className="btn btn-primary"
            onClick={fetchInitialData}
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-6">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Student Name</div>
            <div className="yc-list-cell">Grade</div>
            <div className="yc-list-cell">Division</div>
            <div className="yc-list-cell">Total Amount</div>
            <div className="yc-list-cell">Balance</div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : siblingData.length > 0 ? (
          <div className="yc-list-row-list">
            {siblingData.map((item, index) => (
              <div key={item.student_id || index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-6">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">{item.student_name}</div>
                  <div className="yc-list-cell">{item.class_name}</div>
                  <div className="yc-list-cell">{item.class_division_name}</div>
                  <div className="yc-list-cell">{formatNumber(item.total_amount)}</div>
                  <div className={`yc-list-cell ${isZero(item.balance) ? "yc-amount-positive" : "yc-amount-danger"}`}>
                    {item.balance}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No results found for this parent.</div>
        )}
      </div>
    </div>
  );
}

export default Fee_Due_for_Siblings;
